//@flow
import React from "react";
import {
  Text,
  TouchableOpacity,
  TouchableWithoutFeedback,
  View,
} from "react-native";
import Colors from "@microdoing/shared/constants/Colors";
import theme from "app/Theme/Theme";

type Props = {
  onPressDisabled: () => mixed,
  onPress: () => mixed,
  onPressIn: () => mixed,
  delayPressIn: number,
  text: string,
  testID: string,
  disable: false,
  buttonPropStyle?: {},
  textPropStyle?: {},
  // type: string // light or plain
};

const CardLightButton = ({
  testID,
  disable,
  onPressDisabled,
  onPress,
  onPressIn,
  delayPressIn,
  text,
  buttonPropStyle,
  textPropStyle,
  Icon = null,
}: Props) => {
  let { buttonStyle, textStyle } = styles;
  buttonStyle = buttonPropStyle
    ? { ...buttonStyle, ...buttonPropStyle }
    : buttonStyle;
  textStyle = textPropStyle ? { ...textStyle, ...textPropStyle } : textStyle;

  const result = !disable ? (
    <TouchableOpacity
      onPress={onPress}
      style={buttonStyle}
      testID={testID}
      onPressIn={onPressIn}
      delayPressIn={delayPressIn}
    >
      {Icon}
      <Text style={[textStyle, { marginLeft: Icon ? 0 : 0 }]}>{text}</Text>
    </TouchableOpacity>
  ) : (
    <TouchableWithoutFeedback onPress={onPressDisabled} testID={testID}>
      <View
        style={{ ...buttonStyle, backgroundColor: theme.colors["neutral.400"] }}
      >
        {Icon}
        <Text style={textStyle}>{text}</Text>
      </View>
    </TouchableWithoutFeedback>
  );
  return result;
};

const styles = {
  buttonStyle: {
    height: 40,
    alignItems: "center",
    justifyContent: "center",
    flexDirection: "row",
    backgroundColor: "#F4FBFF",
    borderRadius: 6,
    paddingVertical: 10,
    paddingHorizontal: 15,
  },
  textStyle: {
    color: Colors.pureMain,
    fontSize: 14,
    fontWeight: "bold",
  },
};

export { CardLightButton };
